import { useCallback } from "react";
import useSWR, { BareFetcher, SWRConfiguration, SWRResponse, useSWRConfig } from "swr";
import { hydrateMapIncidents } from "~/helpers/api/mapIncidents";

type Config = SWRConfiguration<HydratedData, Error, BareFetcher<HydratedData>>;
type Data = Array<MapIncident>;
type HydratedData = Array<HydratedMapIncident>;
type Response = SWRResponse<HydratedData, Error>;

export default function useMapIncidents(enabled: boolean = true, config?: Config): Response {
  const { fetcher: baseFetcher } = useSWRConfig();

  const fetcher = useCallback<BareFetcher<HydratedData>>(async (...args) => {
    if (baseFetcher === undefined) {
      throw new Error("No base fetcher defined.");
    }

    const data = (await baseFetcher(args) as Data);

    return hydrateMapIncidents(data);
  }, [baseFetcher]);

  return useSWR<HydratedData, Error>(enabled ? "/map-incidents" : null, { fetcher, ...config });
}
